import type { TripConfig } from '../types';

/** Project the live itinerary into Schedule's cards without owning another copy. */
export function scheduleActivities(itinerary: TripConfig['itinerary'], dates: { date: string }[]): any[] {
  const acts: any[] = [];
  const seen = new Set<string>();
  for (const { date } of dates) {
    const data = itinerary?.[date];
    if (!data) continue;
    for (const [field, type] of [['attractions', 'attraction'], ['eats', 'eat'], ['nightlife', 'nightlife'], ['shopping', 'shopping']] as const) {
      for (const item of data[field] || []) {
        if (!item?.id || seen.has(item.id)) continue;
        seen.add(item.id);
        acts.push({
          id: item.id, name: item.name, category: (item as any).category || (item as any).meal, type,
          inPlan: item.inPlan ?? (item.imported ? true : false),
          address: item.address, lat: (item as any).lat, lng: (item as any).lng,
          notes: item.notes, addedBy: item.addedBy, dayDate: date, participantIds: item.participantIds,
        });
      }
    }
    for (const t of data.transports || []) {
      if (t.isRental) continue;
      const id = t.id || t.flightNum || String(t.dep);
      if (!id || seen.has(id)) continue;
      seen.add(id);
      acts.push({
        id, name: t.from && t.to ? `${t.from} → ${t.to}` : (t.flightNum || t.carrier || 'Transport'),
        category: t.mode || (t as any).type, type: 'transport', inPlan: true,
        dep: t.dep, arr: t.arr, depTz: t.depTz, arrTz: t.arrTz,
        fromCode: t.fromCode, toCode: t.toCode, from: t.from, to: t.to,
        fromCity: t.fromCity, toCity: t.toCity, participantIds: t.participantIds,
      });
    }
  }
  return acts;
}
